module.exports = __webpack_public_path__ + "static/media/ship-bg-mobile-europa.4a2d6b07.jpg";